class ProductGallery extends HTMLElement {
  constructor() {
    super();
    this.init();

    // Add resize observer to update container height
    if (typeof ResizeObserver == "undefined") return;
    const resizeObserver = new ResizeObserver((entries) => this.update());
    resizeObserver.observe(this);

    // Bind event listeners
    if (this.navItems && this.navItems.length > 0) {
      this.navItems.forEach((item) =>
        item.addEventListener("click", this.onNavItemClick.bind(this))
      );
    } else {
      console.log("Cannot find nav items for product gallery");
    }

    if (this.prevButton && this.nextButton) {
      this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
      this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
    }
    // Listen for variant selection change to make current variant image active
    // window.addEventListener('message', this.onVariantChange.bind(this));
    messenger.listen(
      messenger.topics.VARIANT_CHANGE,
      /**
       *
       * @param {Variant} variant
       */
      (variant) => {
        this.onVariantChange(variant);
      },
      "ProductGallery"
    );
  }

  init() {
    // Set up our DOM element variables
    this.imagesContainer = this.querySelector(".product-gallery__images");
    this.navItems = this.querySelectorAll(".product-gallery__nav-item");
    this.images = this.querySelectorAll(".product-gallery__image");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    // If there is no active images set the first image to active
    if (this.findCurrentIndex() === -1) {
      this.setCurrentImage(this.images[0]);
    }
  }

  /**
   *
   * @param {Variant} variant
   * @returns
   */
  onVariantChange(variant) {
    // console.log("Variant changed: ", variant);
    if (
      !variant ||
      !this.images ||
      this.images.length === 1 ||
      !variant.featured_media
    )
      return;
    const currentImage = Array.from(this.images).find(
      /**
       *
       * @param {HTMLImageElement} item
       * @returns
       */
      (item) => item.dataset.mediaId == variant.featured_media.id
    );
    if (currentImage) {
      this.setCurrentImage(currentImage);
      this.scrollToThumbnail(variant);
    }
  }

  onNavItemClick(event) {
    const mediaId = event.target.closest("li").dataset.mediaId;
    if (!this.images) return;
    this.images.forEach((item) =>
      item.classList.remove("product-gallery__image--active")
    );
    this.setCurrentImage(
      Array.from(this.images).find((item) => item.dataset.mediaId === mediaId)
    );
  }

  update() {
    this.style.height = `${this.imagesContainer.offsetHeight}px`;
    if (!this.prevButton || !this.nextButton || !this.images) {
      // console.log("Cannot find elements in image gallery");
      return;
    }
    this.prevButton.removeAttribute("disabled");
    this.nextButton.removeAttribute("disabled");
    if (this.findCurrentIndex() === 0)
      this.prevButton.setAttribute("disabled", "true");
    if (this.findCurrentIndex() === this.images.length - 1)
      this.nextButton.setAttribute("disabled", "true");
  }

  setCurrentImage(elem) {
    if (!this.images) {
      // console.log("Cannot find images in image gallery");
      return;
    }
    this.images.forEach((item) =>
      item.classList.remove("product-gallery__image--active")
    );
    elem.classList.add("product-gallery__image--active");
    this.update();
  }

  findCurrentIndex() {
    if (!this.images) {
      // console.log("Cannot find images in image gallery");
      return;
    }
    return Array.from(this.images).findIndex((item) =>
      item.classList.contains("product-gallery__image--active")
    );
  }

  /**
   * @param {MouseEvent} event
   * @returns {void}
   */
  onButtonClick(event) {
    event.preventDefault();
    let index = this.findCurrentIndex() || 0;
    // if (!index) {
    //   console.log("Cannot find current index in image gallery");
    //   return;
    // }
    if (!this.images || !this.images[index]) {
      // console.log("Cannot find current image in image gallery");
      return;
    }
    if (event.currentTarget && event.currentTarget.name === "next") {
      index++;
    } else {
      index--;
    }
    this.setCurrentImage(this.images[index]);
  }

  /**
   *
   * @param {Variant} variant
   * @returns
   */
  scrollToThumbnail(variant) {
    const variantFeaturedImage =
      variant.featured_image && variant.featured_image.src
        ? variant.featured_image.src
        : null;
    if (!variantFeaturedImage) {
      // console.log("Cannot find featured image in variant");
      return;
    }

    const imageSlug = variantFeaturedImage.split(".com")[1];

    const productGalleryNavList = this.querySelector(".product-gallery__nav");
    if (!productGalleryNavList) {
      // console.log("Cannot find product gallery navigation list");
      return;
    }

    const allThumbnails = Array.from(
      productGalleryNavList.querySelectorAll("img")
    );

    const thumbnailToScrollTo = allThumbnails.find((thumbnail) =>
      thumbnail.srcset.includes(imageSlug)
    );

    if (!thumbnailToScrollTo) {
      // console.log("Cannot find thumbnail to scroll to");
      return;
    }

    /**
     * @type {HTMLElement | null}
     */
    const elementToScrollTo = thumbnailToScrollTo.closest(
      ".product-gallery__nav-item"
    );
    if (!elementToScrollTo) {
      // console.log("Cannot find element to scroll to");
      return;
    }

    const isMobile = () => window.innerWidth <= 768;

    if (isMobile()) {
      productGalleryNavList.scrollTo({
        left: elementToScrollTo.offsetLeft,
        behavior: "smooth",
      });
    } else {
      productGalleryNavList.scrollTo({
        top: elementToScrollTo.offsetTop,
        behavior: "smooth",
      });
    }
  }
}

customElements.define("product-gallery", ProductGallery);

/* Gallery arrows */
document.addEventListener("DOMContentLoaded", () => {
  /**
   * @type {NodeListOf<HTMLImageElement> | null}
   */
  const thumbnails = document.querySelectorAll(".product-gallery__nav-item");
  /**
   * @type {HTMLButtonElement | null}
   */
  const prevButton = /** @type {HTMLButtonElement | null} */ (
    document.getElementById("prev-thumb")
  );
  /**
   * @type {HTMLButtonElement | null}
   */
  const nextButton = /** @type {HTMLButtonElement | null} */ (
    document.getElementById("next-thumb")
  );
  /**
   * @type {HTMLDivElement | null}
   */
  const container = /** @type {HTMLDivElement | null} */ (
    thumbnails && thumbnails[0] ? thumbnails[0].parentElement : null
  );

  if (!thumbnails || !prevButton || !nextButton || !container) {
    // console.log("Cannot find elements");
    return;
  }

  let currentIndex = 0;

  const isMobile = () => window.innerWidth <= 768;

  const calculateVisibleCount = () => {
    if (isMobile()) {
      const containerWidth = container.offsetWidth;
      const thumbnailWidth = thumbnails[0].offsetWidth;
      return Math.floor(containerWidth / thumbnailWidth);
    } else {
      const containerHeight = container.offsetHeight;
      const thumbnailHeight = thumbnails[0].offsetHeight;
      return Math.floor(containerHeight / thumbnailHeight);
    }
  };

  let visibleCount = calculateVisibleCount();

  const updateButtons = () => {
    const maxScroll = isMobile()
      ? container.scrollWidth - container.clientWidth
      : container.scrollHeight - container.clientHeight;

    prevButton.style.display =
      container.scrollLeft > 0 || container.scrollTop > 0 ? "block" : "none";
    nextButton.style.display =
      container.scrollLeft < maxScroll || container.scrollTop < maxScroll
        ? "block"
        : "none";

    prevButton.disabled = container.scrollLeft <= 0 && container.scrollTop <= 0;
    nextButton.disabled =
      container.scrollLeft >= maxScroll || container.scrollTop >= maxScroll;
  };

  const scrollToThumbnail = () => {
    const activeThumbnail = thumbnails[currentIndex];

    if (isMobile()) {
      container.scrollTo({
        left: activeThumbnail.offsetLeft,
        behavior: "smooth",
      });
    } else {
      container.scrollTo({
        top: activeThumbnail.offsetTop,
        behavior: "smooth",
      });
    }
  };

  prevButton.addEventListener("click", () => {
    if (currentIndex > 0) {
      currentIndex--;
      scrollToThumbnail();
      setTimeout(updateButtons, 300); // Ensure buttons update after scroll
    }
  });

  nextButton.addEventListener("click", () => {
    if (currentIndex + visibleCount < thumbnails.length) {
      currentIndex++;
      scrollToThumbnail();
      setTimeout(updateButtons, 300); // Ensure buttons update after scroll
    }
  });

  const onResize = () => {
    visibleCount = calculateVisibleCount();
    updateButtons();
  };

  const onScroll = () => {
    updateButtons();
  };

  window.addEventListener("resize", onResize);
  container.addEventListener("scroll", onScroll);

  visibleCount = calculateVisibleCount();
  updateButtons();
});

document.addEventListener("DOMContentLoaded", () => {
  const lastImageLink = document.querySelector("#sizechart");
  if (!lastImageLink) return;

  lastImageLink.addEventListener("click", (event) => {
    event.preventDefault();

    const gallery = document.querySelector("product-gallery");
    if (!gallery) return;

    const images = gallery.querySelectorAll(".product-gallery__image");
    const lastImage = images[images.length - 1];

    if (lastImage) {
      gallery.setCurrentImage(lastImage);

      // Smooth scrolling (if applicable)
      lastImage.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  });
});
